import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import registerServiceWorker from './registerServiceWorker';
import 'bootstrap/dist/css/bootstrap.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitterSquare, faGithubSquare, faYoutubeSquare } from '@fortawesome/free-brands-svg-icons';
import mellon from './static/mellon_1.jpg';
import me from './static/me.jpg';
import exposing from './static/3392874.pdf';
import tith from './static/tith.pdf';
import codeifying from './static/codeifying.pdf'

library.add(faTwitterSquare);
library.add(faGithubSquare);
library.add(faYoutubeSquare);

const myname = {
    first: 'kristen',
    last: 'escher',
    nick: 'nel'
};

const d = new Date();
const year = d.getFullYear();

function Index() {
    return (
        <div className="index">
            <div className="description">
                <p>
                    i am a bellwether postdoctoral scholar at the uc berkeley school of information, supervised by professor deirdre mulligan. i completed my ph.d. in computer science & engineering at the university of michigan, advised by dr. nikola banovic && dr. ben green. computational law + critical computing. 
                </p>
                <p>
                    holler: nelescher [AT] berkeley [DOT] edu
                </p>
            </div>
            <div className="me">
                <img src={me} className="me_pic" alt="it me"/>
            </div>
        </div>

    );
}

function About() {
    return (
        <div className="about">
            <h4>education</h4>
            <h5><u>university of michigan</u></h5>
            <p>computer science & engineering, ph.d. 2019 - 2025.</p>
            <p>computer science & engineering, m.s. 2019.</p>
            <p><span alt="juris doctor">&#633;o&#647;&#596;op s&#7433;&#633;n&#638;</span> 2016.</p>
            <h5><u>northwestern university</u></h5>
            <p>cognitive science, b.a. 2013.</p>

            <br></br>
            <h4>selected experience</h4>
            <h5><u>university of michigan</u></h5>
            <p>graduate student research assistant. winter 2019 - 2025.</p>
            <p>graduate student instructor, <a class="secret_link" href ="https://lsa.umich.edu/csp">comprehensive studies program</a>. eecs 183: elementary programming concepts. fall 2021 - winter 2022.</p>
            <p>graduate student instructor. eecs 485: web databases and information systems. fall 2018.</p>
            <p>graduate student instructor. eecs 183: elementary programming concepts. fall 2015 - winter 2018.</p>
            <h5><u>microsoft</u></h5>
            <p>research intern -- rise. 2022.</p>
            <p>software engineering intern. 2018.</p>
            <p>legal intern -- iipg & regulatory affairs. 2014.</p>
            <h5><u>qualtrics</u></h5>
            <p>software engineering intern. 2017.</p>
            <h5><u>dechert, llp</u></h5>
            <p>patent litigation summer associate. 2015.</p>
        </div>

    );
}

function Teaching() {
    return (
        <div className="teaching">
            <div>
                <h4>eecs 485: web databases and information systems</h4>
                <h5>graduate student instructor</h5> 
                <h5>fall 2018</h5>
            </div>
            <br></br>
            <div>
                <h4>eecs 183: elementary programming concepts</h4>
                <h5>graduate student instructor</h5>
                <h5>fall 2015-winter 2018</h5>
            </div>
        </div>
    );
}

function Research() {
    return (
        <div className="research">
            <div>
                
                <h4>articles</h4>

                <p>Algorithm Auditing Policies Rest on Flawed Assumptions About Public Sector Systems.<br/> 
                <u>Nel Escher</u>, Nikola Banovic, and Ben Green.<br/>
                Accepted to FAccT 2026.<br/>
                </p>

                <p>Empire Amplifier: Uncovering and Contesting the Prioritization of Colonial Content on Platforms Through Community-Informed Algorithmic Auditing.<br/> 
                <u>Nel Escher</u>, Bakyt Yrysov, Ashley McDermott, Daniel Chechelnitsky, Hermela Berehan Benyam, and Nikola Banovic.<br/>
                Accepted to CSCW 2026.<br/></p>
                <p><a href="https://arxiv.org/abs/2604.27498">Pre-Print</a> <a href="https://www.wired.com/story/youtube-promote-russian-language-kyrgyzstan/">[Wired Coverage]</a> <a href="https://cse.engin.umich.edu/stories/youtube-recommendations-can-sideline-heritage-language-content-study-finds">[Michigan Research Profile]</a></p>

                <p>The Digital Dynamics of Language Vitality: Exploring Child-Algorithm Interactions on YouTube and Language Shift in Bishkek, Kyrgyzstan.<br/> 
                Ashley McDermott and <u>Nel Escher</u>.<br/>
                American Anthropologist. <i>(Minor Revisions)</i><br/>
                </p>

                <p>Code-ifying the Law: How Disciplinary Divides Afflict the Development of Legal Software.<br/> 
                <u>Nel Escher</u>, Jeffrey Bilik, Nikola Banovic, and Ben Green.<br/>
                Proc. ACM Hum.-Comput. Interact. 8, CSCW2, Article 398 (November 2024), 37 pages. </p>
                <p><a href="https://dl.acm.org/doi/10.1145/3686937">Publisher</a> <a href={codeifying}>PDF</a></p>
                <p>Hexing Twitter: Channeling Ancient Magic to Bind Mechanisms of Extraction.<br/> 
                <u>Nel Escher</u> and Nikola Banovic.<br/>
                In <i>Extended Abstracts of the CHI Conference on Human Factors in Computing Systems</i>. (alt.chi `24). ACM, New York, NY, USA, 6 pages. </p>
                <p><a href="https://dl.acm.org/doi/10.1145/3613905.3644071">Publisher</a> <a href={tith}>PDF</a></p>
                <p>Ludification as a Lens for Algorithmic Management: A Case Study of Gig-Workers’ Experiences of Ambiguity in Instacart Work. <br/> 
                Ramesh, Divya, Caitlin Henning, <u>Nel Escher</u>, Haiyi Zhu, Min Kyung Lee, and Nikola Banovic.<br/>
                In <i>Proceedings of the 2023 ACM Designing Interactive Systems Conference</i>. (DIS `23). 638-651. </p>
                <p><a href="https://dl.acm.org/doi/10.1145/3563657.3596004">Publisher</a></p>
                <p>Exposing Error in Poverty Management Technology: A Method for Auditing Government Benefits Screening Tools.<br/> 
                <u>Nel Escher</u> and Nikola Banovic.<br/>
                In <i>PACM HCI</i>. 4, CSCW1, Article 64 (May 2020) (CSCW `20). ACM, New York, NY, USA, 20 pages. </p>
                <p><a href="https://dl.acm.org/doi/10.1145/3392874">Publisher</a> <a href={exposing}>PDF</a> <a href="https://www.post-gazette.com/news/social-services/2020/09/14/researchers-study-pa-benefits-screening-tool-wrong-potential-benefits-applicants-qualifications/stories/202009090122">[Pittsburgh Post-Gazette Coverage]</a></p>
            </div>
            <br></br>
            <div>
                <h4>workshop papers</h4>
                <p>Cod(e)ifying the Law. <br/> 
                <u>Nel Escher</u>, Jeffrey Bilik, Alexander Miller, Jennifer Jiyoung Huseby, Divya Ramesh, Alice Liu, Sam Mikell, Nina Cahill, Ben Green, Nikola Banovic.<br/>
                In <i>Programming Languages and the Law</i> (POPL `22).</p>
                <p><a href="https://www.youtube.com/watch?v=Qx-I4DD8u7Y&list=PLyrlk8Xaylp4r1KZ6tXmREnt1AH_oTie2">Presentation</a></p>
                <p>Sensuous Visions of a Democratic Socialist Utopia: Translating Computer-Mediated Economic Plans into Speculative Artifacts.<br/>
                <u>Nel Escher</u> and Nikola Banovic.<br/>
                In <i>Understanding the Past, Present, and Future of Design Fictions</i> (CHI `20). Virtual.</p>
            </div>
            <div>
                <h4>awards</h4>
                <p>Equity-centered Engineering Award - $3000 (2023)<br/> 
                Three Minute Thesis Competition, Engineering Graduate Symposium <br/>
                University of Michigan, College of Engineering
                </p>
                <p>18th Annual CSE Graduate Student Honors Competition - $1560 (2021)<br/>
                Presentation: <i>Cod(e)ifying the Law</i>, First Place <br/>
                University of Michigan, College of Engineering</p>
            </div>
        </div>
    );
}




function Mellon() {
    return (
        <div className="mellon">
            <img className="mel_pic" src={mellon} alt="a lovely pup" />    
            <p>
                 brauf
            </p>
            <p>
                mellon is my dog.
            </p>
        </div>
    );
}

const page = {
    index: {
        name : "Home",
        content: Index()
    },
    about: {
        name: "About",
        content: About()
    },
    research: {
        name: "Research",
        content: Research()
    },
    mellon: {
        name: "meLLON",
        content: Mellon()
    }
};

class Header extends React.Component {
    render() {
        const name = this.props.name;
        return <h1 className="header whiteText">🦄 hey this is {name}'s site 🦄</h1>;
    }
}

class NavButton extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        this.props.onClick(e.target.value);
    }

    render () {
        const id = this.props.id;
        const label = this.props.label;
        return <button value={id} onClick={this.handleClick} className="nav-button col-lg-2 col-md-2 col-sm-5 col-xs-10">{label}</button>
    }
}

// the content pane
class PaneContent extends React.Component {
    render() {
        const page = this.props.page;
        return (
            <div className="contentPane whiteText">
                {page}
            </div>
        )
    }
}

function Copyright() {  
    return (
        <div>
         <p className="whiteText">Nel Escher &#169; {year}</p>
        </div>
    );
}

function SocialMediaJunk() {
    return(
            <div>
                <a href="https://dl.acm.org/doi/10.1145/3613905.3644071" className="social"><FontAwesomeIcon icon={['fab', 'twitter-square']} size="2x"/></a>
                <a href="https://github.com/kescher" className="social"><FontAwesomeIcon icon={['fab', 'github-square']} size="2x"/></a>
                <a href="https://www.youtube.com/watch?v=Uo9hiFFOJcE" className="social"><FontAwesomeIcon icon={['fab', 'youtube-square']} size="2x"/></a>
            </div>
    );
}

function FooterLeftBundle() {
    return (
        <div className="footer_left_bundle" >
            <SocialMediaJunk />
        </div>
    );
}

function FooterRightBundle() {
    return (
        <div className="footer_right_bundle" >
            <Copyright />
        </div>
    );
}

class Footer extends React.Component {
    render() {
        return (
            <div className="footer">
                <div className="footer_across">
                    <FooterLeftBundle />
                    <FooterRightBundle />
                </div>
            </div>
        );
    }
}

function Sparkle(props) {
    const symbol = props.star
    const x = props.x;
    const y = props.y;
    const style = {
        top: y + 'px',
        left: x + 'px',
    };
    const sparkleclass = props.sparkleclass;

    return (
        <div className={sparkleclass} style={style} alt="" >{symbol}</div>
    );
}

class Page extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            display: "index",
        };

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(id) {
        this.setState(() => ({
            display: id
        }));
    }

    render() {
        let get_pages = {
            index: {
                name : "Home",
                content: Index()
            },
            about: {
                name: "About",
                content: About()
            },
            research: {
                name: "Research",
                content: Research()
            },
            mellon: {
                name: "meLLON",
                content: Mellon()
            }
        };

        const pagetext = get_pages;
        const pages = Object.keys(pagetext);
        const navButtons = pages.map((page) => 
            <NavButton key={page} id={page} label={pagetext[page].name} onClick={this.handleClick} />
        );
        const page = pagetext[this.state.display].content;

        return (
            <div className="mainContent">
                <Header name={this.props.name["nick"]} />
                <div className="nav-buttons"> 
                    <div className="row justify-content-center">
                        {navButtons}
                    </div>
                </div>
                <PaneContent page={page} />
                <Footer />
            </div>
        );
    }
}

class SparklePage extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            sparkles: [],
            sparklecounter: 0,
            index: -1,
            play: false
        }

        this.handleMove = this.handleMove.bind(this);
    }

    handleMove(e) {
        var available_class = ["sparkle-left", "sparkle-right", "sparkle-center"];
        var class_index = Math.floor(Math.random() * available_class.length);

        // var available_stars = ["🌛", "🐉 ", "⭐", "🦄"];
        // var available_stars = ["💩"];
        var available_stars = ["☆", "✧", "✶"];

        var star_index = Math.floor(Math.random() * available_stars.length);

        const sparkleclass = available_class[class_index];
        const star = available_stars[star_index];
        const sparkleCounter = this.state.sparklecounter + 1;
        const index = (this.state.index + 1) % 100;

        var sparkles = this.state.sparkles;
        sparkles[index] =
            {
                x: e.clientX,
                y: e.clientY,
                key: sparkleCounter,
                class: sparkleclass,
                symbol: star
            };

        this.setState({
            sparkles: sparkles,
            sparklecounter: sparkleCounter,
            index: index
        });
    }

    render() {
        const name = this.props.name;
        const sparkleinfo = this.state.sparkles;

        const sparkles = sparkleinfo.map((sparkle) =>
            <Sparkle x={sparkle.x} y={sparkle.y} star={sparkle.symbol} sparkleclass={sparkle.class} key={sparkle.key} />
        );

        return (
            <div onMouseMove={this.handleMove} className="sparklePage">
                <Page name={name} />
                {sparkles}
            </div>
        )
    }
}


ReactDOM.render(
    <SparklePage name={myname} pagetext={page}/>, 
    document.getElementById('root')
);